import { ticketOverviewComponent } from './ticketOverview.component';
import { transferringStateName } from '../tickets.state';
import { receivingStateName } from '../tickets.state';
import { TicketType } from '../../ticket/ticket.constants';

export const transferringListStateName = `${transferringStateName}.list`;

export const transferringListState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: transferringListStateName,
    url: '/ticketOverview?page?filter',
    component: ticketOverviewComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticketsType: () => TicketType.Transferring,
    },
  });
};

export const receivingListStateName = `${receivingStateName}.list`;

export const receivingListState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: receivingListStateName,
    url: '/ticketOverview?page?searchTerm?product',
    reloadOnSearch: false,
    component: ticketOverviewComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticketsType: () => TicketType.Receiving,
    },
  });
};
